import { TtOrderSnapshot } from "@/lib/api/risk/brokerage/tt";

interface OrderContextHeaderProps {
  snapshot: TtOrderSnapshot;
}

function Field({ label, value }: { label: string; value: string | number | null | undefined }) {
  return (
    <div className="grid">
      <span className="text-xs text-muted-foreground">{label}</span>
      <span className="text-sm font-medium break-words">{value == null || value === "" ? "-" : value}</span>
    </div>
  );
}

export function OrderContextHeader({ snapshot }: OrderContextHeaderProps) {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2">
      <Field label="Instrument" value={snapshot.instrument_name} />
      <Field label="Account" value={snapshot.trading_account_name} />
      <Field label="User" value={snapshot.user_name} />
      <Field label="B/S" value={snapshot.buy_sell_type} />
      <Field label="Order Qty" value={snapshot.order_quantity} />
      <Field label="Working Qty" value={snapshot.working_quantity} />
      <Field label="Filled Qty" value={snapshot.filled_quantity} />
      <Field label="Remaining" value={snapshot.remaining_quantity} />
      <Field label="Limit Price" value={snapshot.limit_price} />
      <Field label="Time in Force" value={snapshot.time_in_force} />
      <Field label="Text A" value={snapshot.text_a} />
      <Field label="Text B" value={snapshot.text_b} />
      <Field label="Text C" value={snapshot.text_c} />
      <Field label="Text TT" value={snapshot.text_tt} />
      <div className="col-span-2">
        <Field label="GUID Order ID" value={snapshot.guid_order_id} />
      </div>
    </div>
  );
}
